import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User, Mail, Calendar, Clock } from "lucide-react";
import { UsersOutput } from "@/interfaces/users";
import { UsersService } from "@/services/UserService";
import { LoadingSpinner } from "@/components/LoadingSpinner";

export function UserProfile() {
  const [user, setUser] = useState<UsersOutput | null>(null);
  const [loading, setLoading] = useState(true);
  const userService = new UsersService();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await userService.getUserMe();
        setUser(userData);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const formatDate = (dateString?: string | Date) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("pt-BR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <div className="text-center">Usuário não encontrado</div>;
  }

  return (
    <Card className="w-full max-w-md ">
      <CardHeader className="flex flex-col items-center">
        <Avatar className="w-24 h-24">
          <AvatarImage src={user.picture} alt={user.name || "Usuário"} />
          <AvatarFallback>
            {(user.name?.[0] || "U").toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <CardTitle className="mt-4 text-2xl font-bold">
          {user.name || "Usuário Desconhecido"}
        </CardTitle>
        <p className="text-sm text-gray-500">@{user.nickname || "anônimo"}</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center space-x-2">
          <Mail className="w-5 h-5 text-gray-500" />
          <span className="font-semibold">E-mail:</span>
          <span>{user.email || "Não fornecido"}</span>
        </div>
        <div className="flex items-center space-x-2">
          <User className="w-5 h-5 text-gray-500" />
          <span className="font-semibold">ID do Usuário:</span>
          <span>{user.userId || "N/A"}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Clock className="w-5 h-5 text-gray-500" />
          <span className="font-semibold">Último Login:</span>
          <span>{formatDate(user.lastLogin)}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Calendar className="w-5 h-5 text-gray-500" />
          <span className="font-semibold">Membro Desde:</span>
          <span>{formatDate(user.createdAt)}</span>
        </div>
      </CardContent>
    </Card>
  );
}
